import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { buildupHandler, getBuildupData, HTTPStatusCodes } from '../../lib/api';
import { useSocket } from '../../app/providers';
import './AuthPage.css';

const AuthPage = () => {
    const [username, setUsername] = useState('');
    const [apiKey, setApiKey] = useState('');
    const [subscribeVar, setSubscribeVar] = useState(0);
    const [auth, setAuth] = useState(false);
    const [error, setError] = useState(null);
    const didAutoBuildupRef = useRef(false);
    const navigate = useNavigate();
    const socket = useSocket();

    useEffect(() => {
        if (didAutoBuildupRef.current) return;
        didAutoBuildupRef.current = true;

        const cachedUsername = localStorage.getItem('username');
        const cachedApiKey = localStorage.getItem('apiKey');
        if (cachedUsername && cachedApiKey) {
            buildupHandler({ username: cachedUsername, apiKey: cachedApiKey }, setSubscribeVar);
        }
    }, []);

    useEffect(() => {
        if (subscribeVar > 0) {
            const data = getBuildupData();

            if (data && data.status === HTTPStatusCodes.OK) {
                setAuth(true);
                socket.connect();
                navigate('/dashboard');
            } else {
                setAuth(false);
                setError('Authentication failed. Please try again.');
            }
        }
    }, [subscribeVar, navigate, socket]);

    const handleApiKeyChange = (e) => {
        setApiKey(e.target.value);
    };

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);
        buildupHandler({ username, apiKey }, setSubscribeVar);
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-logo">
                    <span className="auth-logo-icon">◈</span>
                    <span className="auth-logo-name">Simulation Exchange</span>
                </div>

                <h2 className="authentication-text">Sign In</h2>
                <p>Enter your credentials to access the trading platform.</p>

                <input
                    type="text"
                    value={username}
                    onChange={handleUsernameChange}
                    placeholder="Username"
                />
                <input
                    type="password"
                    value={apiKey}
                    onChange={handleApiKeyChange}
                    placeholder="API Key"
                />

                <button onClick={handleSubmit}>Sign In</button>

                {auth && (
                    <p
                        style={{
                            color: '#0ecb81',
                            textAlign: 'center',
                            fontSize: '12px',
                            marginTop: '8px',
                        }}
                    >
                        Authenticated — redirecting…
                    </p>
                )}
                {!auth && subscribeVar > 0 && <p className="error">Authentication failed</p>}
                {error && <p className="error">{error}</p>}

                <div className="auth-links">
                    <Link to="/leaderboard" className="admin-link">
                        Leaderboard →
                    </Link>
                    <Link to="/admin" className="admin-link">
                        Admin →
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default AuthPage;
